import { api } from "./client";
export var setAuthTokenToApi = function (token) {
    api.defaults.headers.Authorization = "Bearer " + token;
};
export var removeAuthTokenFromApi = function () {
    delete api.defaults.headers.Authorization;
};
